import { useEffect, useState } from 'react';

import { lerPontuacaoDoJogador } from '../../jogadores/api/jogadores';
import type { PontuacaoDoJogador as Pontuacao } from '../../jogadores/api/jogadores';
import { JanelaModal } from '../../participantes/ui/JanelaModal';

const FASES: Record<string, string> = {
    scanpixel: 'Scan Pixel',
    labpixels: 'Laboratório de Pixels',
    versus: 'Modo Versus',
    menuresolucao: 'Menu Resolução',
};

const numero = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 });

interface PontuacaoDoJogadorProps {
    turmaId: string;
    jogadorId: string;
    nome: string;
    aoFechar: () => void;
}

/**
 * "Ver pontuação" (`DP-RA-010`): a nota de cada fase é o que o jogador soma no ranking individual,
 * pela regra de destino da Pontuação. Fase que leva tudo para o grupo aparece como "Pontua o grupo";
 * sem nada apurado para ele, "—".
 */
export function PontuacaoDoJogador({ turmaId, jogadorId, nome, aoFechar }: PontuacaoDoJogadorProps) {
    const [carga, setCarga] = useState<{ tipo: 'carregando' } | { tipo: 'erro' } | { tipo: 'pronto'; dados: Pontuacao }>({
        tipo: 'carregando',
    });

    useEffect(() => {
        let vivo = true;
        lerPontuacaoDoJogador(turmaId, jogadorId)
            .then((dados) => vivo && setCarga({ tipo: 'pronto', dados }))
            .catch(() => vivo && setCarga({ tipo: 'erro' }));
        return () => {
            vivo = false;
        };
    }, [turmaId, jogadorId]);

    return (
        <JanelaModal titulo={`Pontuação de ${nome}`} aoFechar={aoFechar}>
            {carga.tipo === 'carregando' && <p>Carregando…</p>}
            {carga.tipo === 'erro' && <p>Não foi possível carregar a pontuação. Tente de novo.</p>}
            {carga.tipo === 'pronto' && (
                <table className="tabela-pontuacao-jogador" aria-label="Pontuação por fase">
                    <thead>
                        <tr>
                            <th scope="col">Fase</th>
                            <th scope="col">Nota</th>
                        </tr>
                    </thead>
                    <tbody>
                        {carga.dados.fases.map((fase) => (
                            <tr key={fase.fase}>
                                <td>{FASES[fase.fase] ?? fase.fase}</td>
                                <td>{nota(fase.pontos, fase.pontua_o_grupo)}</td>
                            </tr>
                        ))}
                        <tr className="total">
                            <td>Total</td>
                            <td>{numero.format(carga.dados.total)}</td>
                        </tr>
                    </tbody>
                </table>
            )}
        </JanelaModal>
    );
}

function nota(pontos: number | null, pontuaOGrupo: boolean): string {
    if (pontos !== null) return numero.format(pontos);
    return pontuaOGrupo ? 'Pontua o grupo' : '—';
}
